


















































































import CFMDialog from "@/scripts/CFMDialog";
import { Component } from "vue-property-decorator";

import * as blockui from "@/helpers/block-ui";
import { required } from "vuelidate/lib/validators";

import {CFMDTOSparePartKind } from "@/scripts/services/ClientApiAuto";

@Component<SparePartKindDialog>({
  components: {},
  validations() {
    return {
      sparePartKind: {
        Name: { required }
      }
    };
  }
})
export default class SparePartKindDialog extends CFMDialog {
  sparePartKind: CFMDTOSparePartKind = { Name: "" };

  selectedSparePartKind: CFMDTOSparePartKind = { Name: "" };
  async created() {
    blockui.blockModal(this);
    if (this.isUpdate) {
      const res = await this.apiClient.sparePartKind.sparePartKindGetById({
        id: <number>this.id
      });
      this.sparePartKind = res.data;
    }
  }

  async onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }
    let formData = {
      Id: this.sparePartKind.Id,
      Name: this.sparePartKind.Name,
    };
    blockui.blockModal(this);
    try {
      const response = await this.apiClient.sparePartKind.sparePartKindSave(formData);
      if (response.data.IsSuccess) {
        toastr.success(this.translate("save_successfully"));
        this.saveSucceeded();
        this.close();
      } else {
        const errorMessage = response.data.Message
          ? response.data.Message
          : "Error";
        toastr.error(errorMessage);
      }
    } catch (e) {
      console.log("err", e);
      toastr.error(e);
    } finally {
      blockui.unBlockModal();
    }
  }
}
